<template>
  <p class="lv-tooltip">{{value}}</p>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    }
  }
}
</script>